import { Megaphone } from "lucide-react";

export const CompanyAnnouncement = ({ announcement }) => {
  const message = announcement?.trim();
  if (!message) return null;
  return (
    <aside role="status" className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950" data-testid="company-announcement">
      <Megaphone className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="min-w-0 whitespace-pre-wrap break-words">{message}</p>
    </aside>
  );
};